export default "__VITE_ASSET__CsJa7u7s__"